// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__SKXwG","rootSmall":"AddTileButton_rootSmall__34JG9"};